import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import PageBanner from '../../components/page-banner/page-banner.component';
import Article from '../../components/blog/article/article.component';

export const query = graphql`
  query StrapiBlogArticle($slug: String!) {
    strapiArticle(slug: { eq: $slug }, status: { eq: "published" }) {
      strapiId
      title
      description
      content
      publishedAt
      image {
        publicURL
        childImageSharp {
          fixed {
            src
          }
        }
      }
      category {
        name
      }
      author {
        name
        picture {
          publicURL
          childImageSharp {
            fixed(width: 30, height: 30) {
              src
            }
          }
        }
      }
    }
  }
`;

type BlogArticleProps = {
  data: GatsbyTypes.StrapiBlogArticleQuery;
};

const BlogArticle: React.FC<BlogArticleProps> = ({
  data: {
    strapiArticle: {
      author,
      title,
      content,
      category: { name },
      description,
      publishedAt,
      image: { publicURL },
    },
  },
}) => {
  return (
    <>
      <Helmet
        {...{ title }}
        meta={[
          {
            property: 'og:title',
            content: title,
          },
          {
            name: 'twitter:title',
            content: title,
          },
          {
            name: 'description',
            content: description,
          },
          {
            property: 'og:description',
            content: description,
          },
          {
            name: 'twitter:description',
            content: description,
          },
          {
            property: 'og:type',
            content: 'article',
          },
        ]}
      />
      <PageBanner
        pageTitle={title}
        homePageText="Home"
        homePageUrl="/"
        activePageText={title}
      />
      <Article
        {...{ title, content, publishedAt }}
        thumbnailUrl={publicURL}
        author={{
          name: author.name,
          profilePicUrl: author.picture.publicURL,
        }}
        category={name}
      />
    </>
  );
};

export default BlogArticle;
